module.exports = "<template> <sio-color-picker config.bind=field value.bind=field.value></sio-color-picker> </template> ";